export default "__VITE_ASSET__BUme0kPO__"